// Load ALL images under src/assets/images (including subfolders).
// CRA/webpack supports require.context at build time.
const blogImages = require.context("../assets/images", true, /\.(png|jpe?g|webp|svg)$/);

const RAW_KEYS = blogImages.keys();

export const BLOG_IMAGE_KEYS = RAW_KEYS
    .map((k) => k.replace(/^\.\//, "")) // "blog/foo.png"
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }));

function toComparablePath(value) {
    return String(value || "")
        .replace(/\\/g, "/")
        .replace(/^\.?\//, "")
        .replace(/^assets\/images\//, "")
        .replace(/^images\//, "");
}

export function resolveBlogImageSrc(imageKey) {
    if (!imageKey || typeof imageKey !== "string") return null;

    const input = toComparablePath(imageKey);
    if (!input) return null;

    // 1) Exact match (supports subfolders), e.g. "blog/foo.png"
    const exactRawKey = `./${input}`;
    if (RAW_KEYS.includes(exactRawKey)) {
        try {
            return blogImages(exactRawKey);
        } catch {
            return null;
        }
    }

    // 2) Back-compat: if caller passes just a filename, try to find a unique match.
    const filename = input.replace(/^.*\//, "");
    if (!filename) return null;

    const matches = RAW_KEYS.filter((k) => k === `./${filename}` || k.endsWith(`/${filename}`));
    if (matches.length !== 1) return null;

    try {
        return blogImages(matches[0]);
    } catch {
        return null;
    }
}

